export default function _isFunction(x) {
  return Object.prototype.toString.call(x) === '[object Function]';
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/ramda/es/internal/_isFunction.js
// module id = 432
// module chunks = 1